import { render, staticRenderFns } from "./WillCollectionBooking.vue?vue&type=template&id=070c4f9f&scoped=true"
import script from "./WillCollectionBooking.vue?vue&type=script&lang=js"
export * from "./WillCollectionBooking.vue?vue&type=script&lang=js"
import style0 from "./WillCollectionBooking.vue?vue&type=style&index=0&id=070c4f9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c4f9f",
  null
  
)

export default component.exports